export default __webpack_public_path__ + "static/media/newbackground.c0df7701.jpg";